import { filterSeparator } from "../constants/Filters";

export const hexToRGB = (hex: string, alpha: string | number) => {
    const r = parseInt(hex.slice(1, 3), 16),
        g = parseInt(hex.slice(3, 5), 16),
        b = parseInt(hex.slice(5, 7), 16);
    if (alpha) {
        return 'rgba(' + r + ', ' + g + ', ' + b + ', ' + alpha + ')';
    } else {
        return '' + r + ', ' + g + ', ' + b;
    }
};

export const updateStyleDocument = () => {
    let theme;
    const brand = localStorage.getItem('brand');
    if (brand) {
        theme = JSON.parse(brand).theme;
    }

    if (theme) {
        document.documentElement.style.setProperty('--primary-color', theme.primaryColor);
        if (theme.primaryColor) {
            document.documentElement.style.setProperty('--bs-primary-rgb', hexToRGB(theme.primaryColor, 0));
        }
        document.documentElement.style.setProperty('--bs-danger-rgb', hexToRGB('#fd625e', 0));
        document.documentElement.style.setProperty('--bs-primary', theme.primaryColor);
        document.documentElement.style.setProperty('--secondary-color', theme.secondaryColor);
        document.documentElement.style.setProperty('--primary-dark-color', theme.primaryDarkColor);
        document.documentElement.style.setProperty('--secondary-dark-color', theme.secondaryDarkColor);
        document.documentElement.style.setProperty('--sidebar-bg-color', theme.sidebarBgColor);
        document.documentElement.style.setProperty('--header-bg-color', theme.headerBgColor);
        document.documentElement.style.setProperty('--header-dark-bg-color', theme.headerDarkBgColor);


        document.documentElement.style.setProperty('--modal-header-background', !theme?.modalHeaderBackground || theme?.modalHeaderBackground == "null" ? "#ffffff" : theme?.modalHeaderBackground);
        document.documentElement.style.setProperty('--modal-header-title', !theme?.modalHeaderTitle || theme?.modalHeaderTitle == "null" ? "#b3bac1" : theme?.modalHeaderTitle);
        document.documentElement.style.setProperty('--modal-header-text', !theme?.modalHeaderText || theme?.modalHeaderText == "null" ? "#495057" : theme?.modalHeaderText);

        document.documentElement.style.setProperty('--is-milestone-background', !theme?.isMilestoneBackground || theme?.isMilestoneBackground == "null" ? "#ffffff" : theme?.isMilestoneBackground);
        document.documentElement.style.setProperty('--is-milestone-circle', !theme?.isMilestoneCircle || theme?.isMilestoneCircle == "null" ? "#ffaf27" : theme?.isMilestoneCircle);
        document.documentElement.style.setProperty('--is-milestone-text', !theme?.isMilestoneText || theme?.isMilestoneText == "null" ? "#495057" : theme?.isMilestoneText);

        document.documentElement.style.setProperty('--modal-body-background', !theme?.modalBodyBackground || theme?.modalBodyBackground === "null" ? "#d8dde2" : theme?.modalBodyBackground);
        document.documentElement.style.setProperty('--modal-body-title', !theme?.modalBodyTitle || theme?.modalBodyTitle == "null" ? "#aeb6be" : theme?.modalBodyTitle);
        document.documentElement.style.setProperty('--modal-body-text', !theme?.modalBodyText || theme?.modalBodyText == "null" ? "#495057" : theme?.modalBodyText);

        document.documentElement.style.setProperty('--modal-total-background', !theme?.modalTotalBackground || theme?.modalTotalBackground === "null" ? "#101340" : theme?.modalTotalBackground);
        document.documentElement.style.setProperty('--modal-total-text', !theme?.modalTotalText || theme?.modalTotalText == "null" ? "#f2f1f2" : theme?.modalTotalText);

    }
    return theme;
};

export const transformCFColumns = (dataListOperation: []) => {
    const listFinal: any[] = [];
    Object.entries(dataListOperation).map((item) => {
        const data = item[1] as [];
        if (item[0] === 'customFields') {
            let CustomFields: any = [];
            if (Array.isArray(data) && data.length > 0) {
                CustomFields = data;
            }
            Object.entries(CustomFields).map((itemCf) => {
                const cf: any = itemCf[1];
                listFinal.push({
                    dataField: 'CF' + cf.internalName,
                    text: '',
                    hidden: false,
                    visibleInTable: false,
                    visibleInModalHeader: false,
                    visibleInModalBody: false,
                    visibleInModalFooter: false,
                    visibleInModalTotal: false,
                    isMilestone: false,
                    isCustomField: true,
                    order: 1,
                });
            });
        } else if (item[0] === 'SOcustomFields' || item[0] === 'POcustomFields' || item[0] === 'CRcustomFields' || item[0] === 'WRcustomFields' || item[0] === 'SHcustomFields' || item[0] === 'IPKcustomFields') {
            let CustomFields: any = [];
            if (Array.isArray(data) && data.length > 0) {
                CustomFields = data;
            }
            let Operation = 'CUSTOM_FIELD_';
            switch (item[0]) {
                case 'SOcustomFields':
                    Operation = 'SOCF_';
                    break;
                case 'POcustomFields':
                    Operation = 'POCF_';
                    break;
                case 'CRcustomFields':
                    Operation = 'CRCF_';
                    break;
                case 'WRcustomFields':
                    Operation = 'WRCF_';
                    break;
                case 'SHcustomFields':
                    Operation = 'SHCF_';
                    break;
                case 'IPKcustomFields':
                    Operation = 'IPKCF_';
                    break;
            }

            Object.entries(CustomFields).map((itemCf) => {
                const cf: any = itemCf[1];
                listFinal.push({
                    dataField: Operation + cf.internalName,
                    text: '',
                    hidden: false,
                    visibleInTable: false,
                    visibleInModalHeader: false,
                    visibleInModalBody: false,
                    visibleInModalFooter: false,
                    visibleInModalTotal: false,
                    isMilestone: false,
                    isCustomField: true,
                    order: 1,
                });
            });
        } else {
            listFinal.push({
                dataField: item[0],
                text: '',
                hidden: false,
                visibleInTable: false,
                visibleInModalHeader: false,
                visibleInModalBody: false,
                visibleInModalFooter: false,
                visibleInModalTotal: false,
                isMilestone: false,
                order: 1,
            });
        }
    });
    return listFinal;
};

export const transformCFColumnsData = (dataListOperation: []) => {
    if (dataListOperation != null) {
        Object.entries(dataListOperation).forEach((dataOperation) => {
            const row = dataOperation[1] as any;
            Object.entries(row).map((item) => {
                const data = item[1] as any;
                if (item[0] === 'customFields') {
                    let CustomFields: any = [];
                    if (Array.isArray(data) && data.length > 0) {
                        CustomFields = data;
                    }
                    Object.entries(CustomFields).map((itemCf) => {
                        const cf: any = itemCf[1];
                        row['CF' + cf.internalName] = cf.value;
                    });
                } else if (item[0] === 'SOcustomFields' || item[0] === 'POcustomFields' || item[0] === 'CRcustomFields' || item[0] === 'WRcustomFields') {
                    const operation = item[0].substring(0, 2);
                    let CustomFields: any = [];
                    if (Array.isArray(data) && data.length > 0) {
                        CustomFields = data;
                    }
                    Object.entries(CustomFields).map((itemCf) => {
                        const cf: any = itemCf[1];
                        row[`${operation}CF_` + cf.internalName] = cf.value;
                    });
                }
            });
        });
    }
    return dataListOperation;
};
export const getDynamicAttrUpdated = (data: Record<string, any>) => {
    let filterString = '';
    for (const [key, value] of Object.entries(data)) {
        if (
            key !== 'from' &&
            key !== 'to' &&
            key !== 'Conditions' &&
            !key.startsWith('CF') &&
            !key.startsWith('SOCF') &&
            !key.startsWith('POCF') &&
            !key.startsWith('CRCF') &&
            !key.startsWith('WRCF')
        ) {
            if (value) {
                const arr = Array.from(value).map((element: any) => {
                    return element.value;
                });
                if (arr.length) {
                    const condition = data.Conditions && data.Conditions[key] ? data.Conditions[key].value : "AND"
                    if (arr[0] === 'true' || arr[0] === 'false') {
                        filterString += `, ${key}: "${arr}%%$_${condition}" `;
                    } else {
                        filterString += `, ${key}: "${arr.join(filterSeparator)}%%$_${condition}" `;
                    }
                }
            }
        }
    }
    return filterString;
};

//Get the Attributes for filtering for CFS
export const getDynamicFilterCF = (data: []) => {
    let filterString = '';
    for (const [key, value] of Object.entries(data)) {
        if (
            (key !== 'from' && key !== 'to' && key.startsWith('CF')) ||
            key.startsWith('SOCF') ||
            key.startsWith('POCF') ||
            key.startsWith('CRCF') ||
            key.startsWith('WRCF')
        ) {
            if (value) {
                const arr = Array.from(value).map((element: any) => {
                    return element.value;
                });
                if (arr.length) {
                    if (arr[0] === 'true' || arr[0] === 'false') {
                        filterString += ` ,{internalName: "${key}" , value:"${arr}" `;
                    } else {
                        filterString += ` {internalName: "${key}" , value:"${arr.join(filterSeparator)}" }`;
                    }
                }
            }
        }
    }
    return filterString != '' ? ' customFields: [' + filterString + ']' : '';
};

export const getDynamicAttr = (data: []) => {
    let filterString = '';
    for (const [key, value] of Object.entries(data)) {
        if (key !== 'from' && key !== 'to' && value !== undefined && value !== '') {
            filterString += `, ${key}: "${value}"`;
        }
    }
    return filterString;
};

export const transformObjectKey = (object: any, keyMappingsTest: any) => {
    const transFormedObject: { [key: string]: any } = {};

    for (const key of Object.keys(object)) {
        const transformedKey: any = keyMappingsTest[key] || key;

        transFormedObject[transformedKey] = object[key];
    }
    return transFormedObject;
};


export const buildTree = (items: any, arrayTable: any) => {

    const headers = arrayTable.reduce((acc: any, fields: any) => {

        acc.push({ dataField: fields.dataField, text: fields.text });

        return acc;
    }, []);

    const nodesById: any = {};

    items.forEach((item: any) => {

        nodesById[item.CLGUID] = { id: item.CLGUID, obj: item, packageName: item.CLPackageName };
    });

    const rootNodes: any = [];

    items.forEach((item: any) => {
        if (item.CLUpItemGUID) {
            const parent = nodesById[item.CLUpItemGUID];
            if (parent) {
                if (!parent.children) {
                    parent.children = [];
                }
                parent.children.push(nodesById[item.CLGUID]);
            } else {
                rootNodes.push(nodesById[item.CLGUID]);
            }
        } else {
            rootNodes.push(nodesById[item.CLGUID]);
        }
    });

    return { rootNodes: rootNodes, headers: headers };
};

export function organizeHierarchy(items: any[]): any[] {
    const nodesById: Record<string, any> = {};

    items.forEach((item) => {
        nodesById[item.CLGUID] = {
            ...item,
            children: []
        };
    });

    const rootNodes: any[] = [];

    items.forEach((item) => {
        if (item.CLUpItemGUID) {
            const parent = nodesById[item.CLUpItemGUID];
            if (parent) {
                parent.children.push(nodesById[item.CLGUID]);
            } else {
                rootNodes.push(nodesById[item.CLGUID]);
            }
        } else {
            rootNodes.push(nodesById[item.CLGUID]);
        }
    });

    rootNodes.sort((a, b) => {
        if (a.CLPackageName < b.CLPackageName) return 1;
        if (a.CLPackageName > b.CLPackageName) return -1;
        return 0;
    });

    return rootNodes;
}
export const extractIdAndCleanText = (input: any) => {
    if (input === "All Locations") {
        return input;
    } else if (input) {
        const parts = input.split("@@@");
        parts.pop();
        const cleanedText = parts.join("@@@");
        return cleanedText;
    } else {
        return undefined;
    }
}

export const changeNameLocation = (name: string) => {
    return name ? name.replace(/@@@/g, ' - ') : undefined;
}